import { render } from "./PixelArtCard.vue?vue&type=template&id=2bce07fc&scoped=true"
import script from "./PixelArtCard.vue?vue&type=script&lang=js"
export * from "./PixelArtCard.vue?vue&type=script&lang=js"

import "./PixelArtCard.vue?vue&type=style&index=0&id=2bce07fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bce07fc"]])

export default __exports__